export function swal_option(type, text) {
  var option = {}; // type = [success, error, confirm, info, warn,default]
  switch (type) {
    case "success":
      option = {
        text: text,
        icon: "success",
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        scrollbarPadding: false
      };
      break;
    case "error":
      option = {
        text: text,
        icon: "error",
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        scrollbarPadding: false
      };
      break;
    case "confirm":
      option = {
        text: text,
        icon: "question",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#989da2",
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        scrollbarPadding: false,
      };
      break;
    case "info":
      option = {
        text: text,
        icon: "info",
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        scrollbarPadding: false
      };
      break;
    case "warn":
      option = {
        text: text,
        icon: "warning",
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        scrollbarPadding: false,
      };
      break;
    default:
      option = {
        text: text,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        scrollbarPadding: false
      };
      break;
  }
  return option;
}